export default "__VITE_ASSET__DhLA$o0___"